import { useTranslateMessage } from "@/hooks/useTranslateMessage";
import {
  Control,
  Controller,
  FieldValues,
  get,
  Path,
  PathValue,
  UseFormRegister,
  useFormState,
} from "react-hook-form";

import clsx from "clsx";

interface InputFormProps<FieldsType extends FieldValues> {
  title?: string;
  name: Path<FieldsType>;
  control: Control<FieldsType>;
  type?: React.HTMLInputTypeAttribute;
  defaultValue?: PathValue<FieldsType, Path<FieldsType>>;
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
  disabled?: boolean;
  tooltip?: string;
  rightElement?: React.ReactNode;
  register: UseFormRegister<FieldsType>;
}

export const StyledTextArea = <FieldsType extends FieldValues>({
  control,
  name,
  defaultValue,
  className,
  register,
  title,
}: InputFormProps<FieldsType>) => {
  const { errors } = useFormState({ control });
  const translateMessage = useTranslateMessage();
  const errorMessage = get(errors, name + ".message") as unknown as string;

  const getInput = () => {
    return (
      <textarea
        className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-normal hover:bg-gray-50"
        rows={4}
        cols={50}
        placeholder={title}
        {...register(name)}
      />
    );
  };

  return (
    <div className={clsx("flex flex-col gap-2", className)}>
      <Controller
        control={control}
        name={name}
        render={() => getInput()}
        defaultValue={defaultValue}
      />
      {errorMessage !== "" && (
        <p className="text-xs text-red-500">{translateMessage(errorMessage)}</p>
      )}
    </div>
  );
};
